import { ChangeDetectionStrategy, Component, computed, inject, ViewEncapsulation } from '@angular/core';
import { DecimalPipe, DOCUMENT } from '@angular/common';
import { MetadataEntitySegmentFilterDisplayType } from '@jms/model';
import { DesignSystem } from '@workbuddy/ui/v2/design-system';
import { EntityBoardStore } from '../../state';
import { boardSegmentTilesBridgeStyles, boardSegmentTilesStyleId } from './board.segment.tiles.theme';

@Component({
  selector: 'board-segment-tiles',
  templateUrl: './board.segment.tiles.component.html',
  styleUrls: ['./board.segment.tiles.component.less'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DecimalPipe],
  host: {
    '[attr.data-size]': '$compact() ? "compact" : "default"',
  },
})
export class BoardSegmentTilesComponent {

  protected readonly store = inject(EntityBoardStore);

  private readonly document = inject(DOCUMENT);

  /** Smaller tiles/pills on an embedded board (Job Items, Tasks). Not a third display type. */
  protected readonly $compact = computed(() => this.store.$contextIsEmbedded());

  protected readonly $displayType = computed<MetadataEntitySegmentFilterDisplayType>(() => this.store.$segmentFilterConfig()?.display?.type ?? 'pills');

  public constructor() {

    DesignSystem.Mount(this.document, boardSegmentTilesStyleId, boardSegmentTilesBridgeStyles);
  }

  protected onSelect(id: string): void {

    this.store.selectSegment(id);
  }

  protected countTooltip(id: string): string | null {
    const limit = this.store.$segmentCountLimit();
    if (!this.store.$segmentCountsReady() || !limit || (this.store.$segmentCounts()[id] ?? 0) < limit) return null;
    return `Count limited to ${limit.toLocaleString('en-AU')}. There may be more matching records. Narrow your filters to see a smaller result set.`;
  }
}
